// @flow
import * as React from 'react';
import {
  RadioOptionLabel,
  ValidationSmall,
  RadioInputDiv,
  RadioOptionDiv,
  RadioInputLabelH5,
  RadioOuter,
  RadioInner
} from './RadioInputStyles';

type Option = {
  text: string,
  value: string | number | boolean,
  secondaryText?: string
};
type Props = {
  options: Array<Option>,
  label?: string,
  input: {
    onChange: (value: string) => void,
    value: ?string,
    name: string
  },
  meta?: { error?: string, touched?: boolean },
  readOnly?: boolean,
  onChange?: (value: string) => void,
  renderLabel?: (text: string, secondaryText?: string) => React.Node,
  className?: string
};

class RadioInput extends React.Component<Props> {
  renderError = () =>
    this.props.meta &&
    this.props.meta.touched &&
    this.props.meta.error && (
      <ValidationSmall>{this.props.meta.error}</ValidationSmall>
    );

  handleChange = (event: SyntheticMouseEvent<HTMLInputElement>) => {
    if (this.props.readOnly) {
      return;
    }
    this.props.input.onChange(event.currentTarget.value);
    if (this.props.onChange) {
      this.props.onChange(event.currentTarget.value);
    }
  };

  render() {
    return (
      <RadioInputDiv className={this.props.className}>
        {Boolean(this.props.label) && (
          <RadioInputLabelH5>
            <label>{this.props.label}</label>
          </RadioInputLabelH5>
        )}
        {this.props.options.map(option => {
          const checked = this.props.input.value === String(option.value);
          const id = this.props.input.name + String(option.value);
          return (
            <RadioOptionDiv
              key={String(option.value)}
              readOnly={this.props.readOnly}
            >
              <input
                type="radio"
                name={this.props.input.name}
                value={option.value}
                onChange={this.handleChange}
                checked={checked}
                id={id}
              />
              <RadioOptionLabel htmlFor={id}>
                <RadioOuter checked={checked} readOnly={this.props.readOnly}>
                  {checked && <RadioInner readOnly={this.props.readOnly} />}
                </RadioOuter>
                {this.props.renderLabel ? (
                  this.props.renderLabel(option.text, option.secondaryText)
                ) : (
                  <>
                    {option.text}{' '}
                    {option.secondaryText && (
                      <span>{option.secondaryText}</span>
                    )}
                  </>
                )}
              </RadioOptionLabel>
            </RadioOptionDiv>
          );
        })}
        {this.renderError()}
      </RadioInputDiv>
    );
  }
}

export default RadioInput;
